import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import { UserProvider } from "./context/UserContext";
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <BrowserRouter>
        <HelmetProvider>
          <App />
          <Toaster position="bottom-center" />
      </HelmetProvider>
      </BrowserRouter>
    </UserProvider>
  </React.StrictMode>
);

reportWebVitals();
